import { render, staticRenderFns } from "./StringAttributeEditor.vue?vue&type=template&id=6331e3aa"
import script from "./StringAttributeEditor.vue?vue&type=script&lang=js"
export * from "./StringAttributeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports